import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import packageInfo from '../../../package.json';

const Footer = () => {
  return (
    <footer className="footer" style={{ position: 'unset' }}>
      <Container fluid={true}>
        <Row>
          <Col md={6}>
            {new Date().getFullYear()} © Sos Dottore -{' '}
            <a
              href="/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1e6f5c' }}>
              Privacy Policy
            </a>{' '}
            ,{' '}
            <a
              href="https://www.iubenda.com/privacy-policy/21991191/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1e6f5c' }}>
              Cookie Policy
            </a>{' '}
            e{' '}
            <a
              href="https://www.iubenda.com/termini-e-condizioni/21991191"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1e6f5c' }}>
              Termini e Condizioni
            </a>
          </Col>
          <Col md={6}>
            <div className="text-sm-right d-none d-sm-block">
              Design & Develop with{' '}
              <i className="mdi mdi-heart text-danger"></i> by SosDottore.it - v
              {packageInfo.version}
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
